import { useState } from "react";
import { Paper, InputBase, IconButton, CircularProgress } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import { search as apiSearch } from "../../services/api";

const SearchBar = ({ opts = {} }) => {
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSearch = async () => {
    const query = q.trim();
    if (!query || loading) return;

    setLoading(true);
    try {
      const res = await apiSearch(query, opts); // { results, total, q }
      // push to results page; pass data via state so page can optionally use it
      console.log("res", res);
      navigate(`/search?q=${encodeURIComponent(query)}`, { state: res });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch();
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        minWidth: { xs: 300, sm: 420 },
        p: "2px 4px",
        border: "1px solid rgba(0,0,0,0.6)",
        bgcolor: "rgba(0,0,0,0.07)",
        ml: 2,
      }}
      elevation={0}
    >
      <InputBase
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search using keywords, category, oem part # / name"
        sx={{ color: "inherit", ml: 1, flex: 1 }}
        inputProps={{ "aria-label": "search" }}
      />
      <IconButton
        type="button"
        aria-label="search"
        onClick={handleSearch}
        disabled={loading}
        sx={{ p: 1 }}
      >
        {loading ? <CircularProgress size={20} /> : <SearchIcon />}
      </IconButton>
    </Paper>
  );
};

export default SearchBar;
